import { render, staticRenderFns } from "./ReachOut.vue?vue&type=template&id=67fa2d86&scoped=true&lang=pug&"
import script from "./ReachOut.vue?vue&type=script&lang=ts&"
export * from "./ReachOut.vue?vue&type=script&lang=ts&"
import style0 from "./ReachOut.vue?vue&type=style&index=0&id=67fa2d86&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fa2d86",
  null
  
)

component.options.__file = "ReachOut.vue"
export default component.exports